import { useFetch } from '@hn-front/utils';
import { transformMarathonStatus } from '../../../supervizors/pages/marathons/api';
var headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
};
export var useMarathons = function () {
    var _a = useFetch('/api/v2/teachers/marathons?filter[status]=current,completed,scheduled', {
        headers: headers,
    }), isLoading = _a.isLoading, response = _a.response, error = _a.error;
    var allMarathons = (response === null || response === void 0 ? void 0 : response.map(function (d) {
        return ({
            id: d.id,
            grades: d.gradeValues,
            author: d.author.fullName,
            type: transformMarathonStatus(d.status),
            startDate: d.startAt,
            endDate: d.endAt,
        });
    })) || [];
    var marathons = allMarathons.filter(function (m) {
        return ['active', 'completed'].includes(m.type);
    });
    var scheduledMarathons = allMarathons.filter(function (m) { return m.type === 'scheduled'; });
    return { isLoading: isLoading, error: error, marathons: marathons, scheduledMarathons: scheduledMarathons };
};
export var getMarathons = function () {
    return fetch('/api/v2/teachers/marathons', {
        headers: headers,
    })
        .then(function (res) { return res.json(); })
        .then(function (_a) {
        var data = _a.data;
        return data;
    })
        .then(function (data) {
        return data.map(function (d) {
            return ({
                id: d.id,
                grades: d.gradeValues,
                author: d.author.fullName,
                type: transformMarathonStatus(d.status),
                startDate: d.startAt,
                endDate: d.endAt,
            });
        });
    });
};
